import { render } from "./TermsOfUse.vue?vue&type=template&id=7517afe6"
import script from "./TermsOfUse.vue?vue&type=script&lang=js"
export * from "./TermsOfUse.vue?vue&type=script&lang=js"

import "./TermsOfUse.vue?vue&type=style&index=0&id=7517afe6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/TermsOfUse.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7517afe6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7517afe6', __exports__)) {
    api.reload('7517afe6', __exports__)
  }
  
  module.hot.accept("./TermsOfUse.vue?vue&type=template&id=7517afe6", () => {
    api.rerender('7517afe6', render)
  })

}


export default __exports__